import React from 'react'
import { View, Text, StyleSheet } from 'react-native'
import { InfoInCircle } from '../../../../assets/icons'
import { useTranslation } from 'react-i18next'
import useIsMobile from '../../../Contractor/PayablesTab/hooks/useIsMobile'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'

const InfoAlert = () => {
  const { t } = useTranslation('global')
  const isMobile = useIsMobile()
  return (
    <View
      style={
        isMobile
          ? composeStyle(styles.container, styles.containerMobile)
          : styles.container
      }
    >
      <View style={styles.iconWrapper}>
        <InfoInCircle />
      </View>

      <View
        style={
          isMobile
            ? composeStyle(styles.textWrapper, styles.textWrapperMobile)
            : styles.textWrapper
        }
      >
        <Text
          style={
            isMobile
              ? composeStyle(styles.title, styles.textWrapperMobile)
              : styles.title
          }
        >
          {t('integrations.pay-as-guest.enter-password.faster-checkout')}
        </Text>
        <Text style={styles.info}>
          {t('integrations.pay-as-guest.enter-password.info')}
        </Text>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#F4F9FD',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 12,
    paddingBottom: 16,
    paddingRight: 20,
  },
  containerMobile: {
    paddingRight: 10,
  },
  iconWrapper: {
    marginTop: 1,
    height: 50,
    width: 50,
    alignSelf: 'flex-start',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textWrapper: {
    flex: 1,
    maxWidth: '90%',
    alignItems: 'flex-start',
    justifyContent: 'center',
    alignSelf: 'flex-start',
  },
  textWrapperMobile: {
    maxWidth: '100%',
  },
  title: {
    marginTop: 14,
    fontSize: 16,
    fontWeight: '700',
    fontFamily: 'Inter',
    maxWidth: '85%',
    lineHeight: 24,
    color: '#19262F',
    textAlign: 'left',
    marginBottom: 6,
  },
  info: {
    fontSize: 14,
    fontWeight: '400',
    fontFamily: 'Inter',
    lineHeight: 24,
    color: '#082131',
    textAlign: 'left',
  },
})

export default InfoAlert
